jQuery(document).ready(function ($) {

    jQuery('.navbar-burger').on("click", function () {
        jQuery('.m-mobile-menu').fadeToggle(); 
    });

    jQuery('.m-mobile-menu a').on("click", function () {
        jQuery('.m-mobile-menu').fadeOut(); 
        jQuery('.navbar-burger').removeClass('is-active');
    });
});

